import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { ComponentType } from 'react';
import ContractedIcon from 'src/assets/icons/ContractedIcon';
import FavoritesIcon from 'src/assets/icons/FavoritesIcon';
import FormularyIcon from 'src/assets/icons/FormularyIcon';
import OfflineIcon from 'src/assets/icons/OfflineIcon';
import PictureAvailableIcon from 'src/assets/icons/PictureAvailableIcon';
import SpecialOrderIcon from 'src/assets/icons/SpecialOrderIcon';
import AttributeFilterUI, {
  AttributeFilterOption,
} from 'src/components/AttributeFilterUI';
import { extractAttributesFilter } from 'src/sections/shopping_cart/shoppingCartProductMapper';
import { useContextSelector } from 'use-context-selector';
import { ShoppingCartContext } from '../ShoppingCartContext';

const shoppingCartAttributeOptions: AttributeFilterOption[] = [
  {
    type: 'isContracted',
    label: 'Contracted Item',
    icon: <ContractedIcon />,
  },
  {
    type: 'isOfflineSupplierItem',
    label: 'Offline Supplier',
    icon: <OfflineIcon />,
  },
  {
    type: 'productInFavoriteFolder',
    label: 'In Shopping List',
    icon: <FavoritesIcon />,
  },
  {
    type: 'isSpecialOrder',
    label: (
      <span style={{ display: 'block', lineHeight: '1.3', whiteSpace: 'nowrap' }}>
        Special Order - Item may incur
        <br />
        additional shipping charges
      </span>
    ),
    icon: <SpecialOrderIcon />,
  },
  {
    type: 'isImageAvailable',
    label: 'Picture Available',
    icon: <PictureAvailableIcon />,
  },
  {
    type: 'isFormulary',
    label: 'Company Specified',
    icon: <FormularyIcon />,
  },
];

const ShoppingCartAttributesFilter: ComponentType<GridColumnMenuProps> = (columnMenuProps) => {
  const dataState = useContextSelector(ShoppingCartContext, (state) => state.dataState);
  const attributesFilter = extractAttributesFilter(dataState.filter);
  const persistedValue = attributesFilter?.attributes.join(',') ?? '';
  const persistedOperator = attributesFilter?.operator ?? 'or';

  return (
    <GridColumnMenuFilter
      {...columnMenuProps}
      expanded={true}
      hideSecondFilter
      filterUI={(filterUIProps) => (
        <AttributeFilterUI
          {...filterUIProps}
          firstFilterProps={{
            ...filterUIProps.firstFilterProps,
            value: persistedValue || filterUIProps.firstFilterProps.value,
            operator: persistedOperator || filterUIProps.firstFilterProps.operator,
          }}
          attributeOptions={shoppingCartAttributeOptions}
        />
      )}
    />
  );
};

export default ShoppingCartAttributesFilter;
